module.exports = __webpack_public_path__ + "img/arrow-down.27d8f222.svg";